export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "InputNumber",
            data: {
                onChange,
                masks: [/-/g],
                attrs: {
                    placeholder: "Введите кол-во часов",
                    value: settings[name],
                }
            }
        }
    ]
}